import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import Login from './pages/Login';
import PrivacyPolicy from './pages/PrivacyPolicy';
import UserAgreement from './pages/UserAgreement';
import About from './pages/About';
import Dashboard from './pages/Dashboard';
import HomeDashboard from './pages/HomeDashboard';
import TaskReview from './pages/TaskReview';
import UserManagement from './pages/UserManagement';
import SupportTickets from './pages/SupportTickets';
import PaymentManagement from './pages/PaymentManagement';
import ChatRoomManagement from './pages/ChatRoomManagement';
import VerificationReview from './pages/VerificationReview';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <ConfigProvider locale={zhCN}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/login" element={<Login />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/agreement" element={<UserAgreement />} />
          <Route path="/about" element={<About />} />
          <Route element={<ProtectedRoute />}>
            <Route path="/dashboard" element={<Dashboard />}>
              <Route index element={<HomeDashboard />} />
              <Route path="home" element={<HomeDashboard />} />
              <Route path="tasks" element={<TaskReview />} />
              <Route path="users" element={<UserManagement />} />
              <Route path="support" element={<SupportTickets />} />
              <Route path="payments" element={<PaymentManagement />} />
              <Route path="chatrooms" element={<ChatRoomManagement />} />
              <Route path="verification" element={<VerificationReview />} />
            </Route>
          </Route>
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </BrowserRouter>
    </ConfigProvider>
  );
}

export default App;
